import React from 'react';
import Step from "components/MainApp/atoms/Wizard/Step";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import MainDropdownInput from "components/MainApp/atoms/Forms/MainDropdown";

import SelectAutocomplete from 'shared/components/autocomplete';

import styles from "./Step1.module.scss";
import { capitalize } from 'helpers/utils/utils_general';
import i18n from 'i18n';

const countryOptions = [
  {
    label: i18n.t("store.1")
  },
  {
    label: i18n.t("wine.cellar.1")
  },
  {
    label: i18n.t("central.warehouse")
  },
  {
    label: i18n.t("warehouse.2")
  }
]
export class AddBusinessStepOne extends React.Component {
  showRegionFields = false;

  componentDidMount() {
    this.showRegionFields = this.props.businessnode?.country?.value === "ES";
  }

  componentDidUpdate(prevProps) {
    this.showRegionFields = this.props.businessnode?.country?.value === "ES";
  }

  render() {
    const { businessnode, handleChange, handleSelect, handleContinue, countries,
      regions, provinces, cities, enableContinue, error } = this.props;

    const stepContent = (
      <form onSubmit={handleContinue}>
        <div className={styles["add-businessnode-wizard-step-one-content"]}>
          <div className={styles["add-businessnode-wizard-step-one-field"]} data-automation-id="input-name">
            <MainInput
              label={capitalize(i18n.t("name"))}
              required={true}
              id={"businessnode-name"}
              name="name"
              value={businessnode ? businessnode.name : ''}
              handleChange={handleChange}
              maxLength={100}
              error={error.name && error.name}
            />
          </div>
          <div className={styles["add-businessnode-wizard-step-one-field"]} data-automation-id="input-country">
            <SelectAutocomplete
              id="businessnode-country"
              name="country"
              label={i18n.t("country")}
              options={countries}
              placeholder={i18n.t("country")}
              selected={businessnode ? businessnode.country : {}}
              required={true}
              error={error.country && error.country}
              onChange={(id, selectedOption, target) =>
                handleSelect(selectedOption, "country")
              }
            />
          </div>
          {this.showRegionFields && (
            <>
              <div className={styles["add-businessnode-wizard-step-one-field"]} data-automation-id="input-region">
                <SelectAutocomplete
                  id="businessnode-region"
                  name="region"
                  label={i18n.t("community")}
                  options={regions}
                  placeholder={i18n.t("community")}
                  selected={businessnode ? businessnode.region : {}}
                  required={true}
                  disabled={!businessnode || !businessnode.country || businessnode.country === ""}
                  error={error.region && error.region}
                  onChange={(id, selectedOption, target) =>
                    handleSelect(selectedOption, "region")
                  }
                />
              </div>
              <div className={styles["add-businessnode-wizard-step-one-field"]} data-automation-id="input-state">
                <SelectAutocomplete
                  id="businessnode-state"
                  name="state"
                  label={i18n.t("province")}
                  options={provinces}
                  placeholder={i18n.t("province")}
                  selected={businessnode ? businessnode.state : {}}
                  disabled={!businessnode || !businessnode.region || businessnode.region === ""}
                  required={true}
                  error={error.country && error.country}
                  onChange={(id, selectedOption, target) =>
                    handleSelect(selectedOption, "state")
                  }
                />
              </div>
              <div className={styles["add-businessnode-wizard-step-one-field"]} data-automation-id="input-locality">
                <SelectAutocomplete
                  id="businessnode-locality"
                  name="locality"
                  label={i18n.t("municipality")}
                  options={cities}
                  placeholder={i18n.t("municipality")}
                  selected={businessnode ? businessnode.locality : {}}
                  disabled={!businessnode || !businessnode.state || businessnode.state === ""}
                  required={true}
                  error={error.country && error.country}
                  onChange={(id, selectedOption, target) =>
                    handleSelect(selectedOption, "city")
                  }
                />
              </div>
            </>
          )}
          <div className={styles["add-businessnode-wizard-step-one-field"]} data-automation-id="input-address">
            <MainInput
              label={i18n.t("address")}
              required={true}
              id={"businessnode-address"}
              name="address"
              value={businessnode ? businessnode.address : ''}
              handleChange={handleChange}
              maxLength={100}
              error={error.addess && error.addess}
            />
          </div>
          <div className={styles["add-businessnode-wizard-step-one-action-wrapper"]}>
            <button type="submit"
              className={`${styles["add-businessnode-wizard-step-one-action-button"]} ${!enableContinue ? styles["disabled"] : ""}`}
              onClick={enableContinue ? handleContinue : undefined} >
              {i18n.t("continue").toUpperCase()}
            </button>
          </div>
        </div>
      </form>
    );

    return (
      <div className={styles["add-businessnode-wizard-step-one-container"]}>
        <Step title="" content={stepContent}></Step>
      </div>
    );
  }
}

export default AddBusinessStepOne;
